import React, { useRef, useState, useEffect } from "react";
import useOutSideAlerter from "../hooks/useOutsideAlerter";
import { useNavigate, Link } from "react-router-dom";
import "./FullSpanAddSourceModal.css";
import ToggleBookmarkContainer from "../components/ToggleBookmarkContainer";
import BackArrow from "../icons/iconComponents/BackArrow";
import SvgShareIcon from "../icons/iconComponents/ShareIcon.js";
import SvgNoteIcon from "../icons/iconComponents/NoteIcon";
import SvgNote from "../icons/iconComponents/Note";
import ContentBoxWrapper from "../components/ContentBoxWrapper";
import { NoteModal, ShareModal } from "../components/Modal";
import NoteNav from "../components/NoteNav";
import parse from "html-react-parser";
import SvgNoteToggle from "../icons/iconComponents/NoteIcon";
import { updateLocalSetting } from "../Environment";
import { useTheme } from "../contexts/ThemeContext";
import { timeDifferenceForDate } from "../utils";
import environment from "../Environment";
import { commitLocalUpdate } from "react-relay";

import AddSourceModalComponentContainer from "./AddSourceModalComponentContainer";

function FullSpanAddSourceModal(props) {
	const [isActivated, setIsActivated] = useState(props.isModalActive);
	const [isSummary, setIsSummary] = useState(false);
	const [isShareModalActive, setIsShareModalActive] = useState(false);
	const [selectedText, setSelectedText] = useState("");
	const [isNoteModalActive, setIsNoteModalActive] = useState(false);
	const [isNoteNavActive, setIsNoteNavActive] = useState(false);
	const theme = useTheme();

	// let [filterString, setFilterString] = useState("");
	const navigate = useNavigate();
	const { isNoteViewActivated, isNewFolderView } = props.settings;
	const settings = props.settings;
	const user = props.user;
	const { isPremium } = props.user;

	const wrapperRef = useRef(null);
	let isOutside = useOutSideAlerter(wrapperRef);

	function onCloseClick(e) {
		e.preventDefault();
		commitLocalUpdate(environment, store => {
			const record = store.getRoot().getLinkedRecord("settings");
			record.setValue(false, "isFullScreenAddSourceModalActivated");
		});
	}

	function onAddSourceClick(e) {
		e.preventDefault();
		navigate("/add-source");
	}

	function onCreateFeedClick(e) {
		e.preventDefault();
		commitLocalUpdate(environment, store => {
			const record = store.getRoot().getLinkedRecord("settings");
			record.setValue(true, "isNewFolderView");
		});
	}

	function onBookmarkClick(e) {
		e.preventDefault();
		updateLocalSetting("isFullScreenMenuActivated", false);
		commitLocalUpdate(environment, store => {
			const record = store.getRoot().getLinkedRecord("settings");
			record.setValue(true, "isBookmarkView");
			record.setValue("Bookmarked Posts", "metaDescription");
			record.setValue("", "metaSourceName");
			record.setValue(false, "isPostNoteView");

			record.setValue(false, "isAdvancedSearch");
			record.setValue("", "hasPhrase");
			record.setValue("", "withoutWords");
			record.setValue("", "withWords");
			record.setValue("", "searchScope");
			record.setValue("", "searchTime");
			record.setValue(false, "allSubscriptions");

			navigate("/home");
		});
	}

	function handleMouseUp(e) {
		e.preventDefault();
		setSelectedText(window.getSelection().toString());
	}

	let isOpen = isActivated ? "open" : "close";
	let isHidden = isActivated ? "" : "inactive";

	function onChange(e) {
		e.preventDefault();
		// setFilterString(e.target.value);
		// console.log(filterString);
	}

	function onNoteViewClick(e) {
		e.preventDefault();
		// setIsBookmarkView(false);

		commitLocalUpdate(environment, store => {
			const record = store.getRoot().getLinkedRecord("settings");
			record.setValue(true, "isPostNoteView");
			record.setValue(false, "isBookmarkView");
			record.setValue("Posts with Notes", "metaDescription");
			record.setValue("", "metaSourceName");

			record.setValue(false, "isAdvancedSearch");
			record.setValue("", "hasPhrase");
			record.setValue("", "withoutWords");
			record.setValue("", "withWords");
			record.setValue("", "searchScope");
			record.setValue("", "searchTime");
			record.setValue(false, "allSubscriptions");
		});

		updateLocalSetting("isFullScreenMenuActivated", false);

		navigate("/home");
	}

	let noteNavVisible = localStorage.getItem("Settings.isNoteNavActivated");

	return (
		<div
			className={`fullspan-source-modal-container fullspan-source-modal-container-${isOpen} theme-${theme.light}`}
		>
			<div className={`theme-${theme.light} detailview-wrapper`}>
				<div className={`detailview-header theme-${theme.light}`}>
					<div
						className={`theme-${theme.light} theme-${theme.border +
							"-true"} detailview-header-room theme-${
							theme.light
						}`}
					>
						<BackArrow
							className={`detailview-backarrow detailview-header-icon`}
							onClick={onCloseClick}
						/>
						<div className="detailview-header-icons"></div>
						<div></div>
					</div>
				</div>
				<div
					className={`detailview-content detailview-content-${isNoteNavActive}`}
				>
					<div className={`detailview-content-matter`}>
						<AddSourceModalComponentContainer
							settings={settings}
							user={user}
							selectedSubId={props.selectedSubId}
							selectedSubName={props.selectedSubName}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default FullSpanAddSourceModal;
